import { BiLeftArrowAlt } from "react-icons/bi";
import { useLocation, useNavigate, Link } from "react-router";
import {
  ROUTE_USERS,
  ROUTE_USERS_PROFILE,
  ROUTE_USERS_ROLES,
} from "../../SharedModule/utils/constants";
import { TabLabel } from "../../SharedModule/components/TabLabel";
import { UserWithProfileType } from "../types/users-module-types";
import { CheckSkeleton } from "../../SharedModule/utils/checkSkeleton";

export default function HeaderUsersModule({
  actualUser,
  isLoadingUserProfile,
}: Readonly<{
  actualUser: UserWithProfileType;
  isLoadingUserProfile: boolean;
}>) {
  const navigate = useNavigate();
  const location = useLocation();

  const checkActiveTab = (tab: string) => {
    return location.pathname.endsWith(tab);
  };

  const onClickHandler = (route: string, user: UserWithProfileType) => {
    let actualAsuiteId = user.asuiteId ?? 0;
    navigate(route.replace(":userId", String(actualAsuiteId)), {
      state: { user: user },
    });
  };

  return (
    <div className="header-module-container">
      <Link
        className="back-button-container text-decoration-none"
        to={ROUTE_USERS}
      >
        <BiLeftArrowAlt className="back-button-arrow" />
        <span className="back-button-text">Back to User List</span>
      </Link>
      <CheckSkeleton
        isLoading={isLoadingUserProfile}
        style={{ width: "25%", height: "38px" }}
      >
        <div className="header-module-title">
          {actualUser?.fullName}{" "}
          {actualUser?.isActive ? (
            <span className="bagde active-bagde">Active</span>
          ) : (
            <span className="bagde inactive-bagde">Inactive</span>
          )}
        </div>
      </CheckSkeleton>
      <CheckSkeleton
        isLoading={isLoadingUserProfile}
        style={{ width: "25%", height: "20px" }}
      >
        <div className="header-module-subtitle">ID: {actualUser?.asuiteId}</div>
      </CheckSkeleton>
      <div className="d-flex flex-row mt-3">
        <TabLabel
          key="userInformation"
          active={checkActiveTab("profile")}
          classes="top-nav-tab"
          onClick={() => onClickHandler(ROUTE_USERS_PROFILE, actualUser)}
          disabled={isLoadingUserProfile}
        >
          <div className="header-module-link">User Information</div>
        </TabLabel>
        <TabLabel
          key="roles"
          active={checkActiveTab("roles")}
          classes="top-nav-tab"
          onClick={() => onClickHandler(ROUTE_USERS_ROLES, actualUser)}
          disabled={isLoadingUserProfile}
        >
          <div className="header-module-link">Roles</div>
        </TabLabel>
      </div>
      <hr className="header-separator" />
    </div>
  );
}
